import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ConfirmationButtonDialogComponent} from './confirmation-button-dialog.component';
import {DialogModule} from '../../../../../modules/common/dialog/dialog.module';
import {ButtonModule} from '../../../../../modules/core/component/button/button.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        DialogModule,
        ButtonModule,
    ],
    declarations: [
        ConfirmationButtonDialogComponent,
    ],
    exports: [
        ConfirmationButtonDialogComponent
    ],
})
export class ConfirmationButtonDialogModule {}
